var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147,
    height: 146,
    viewBox: "0 0 147 146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-40 -28)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.199,
    cy: 111.701,
    fill: "#F1F4F4",
    rx: 47.828,
    ry: 47.615
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#BECACF",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.582 101.788c-5.381-30.43-34.313-50.779-64.622-45.45-30.308 5.329-50.516 34.318-45.135 64.748 5.381 30.43 34.313 50.78 64.622 45.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.537 106.375c-2.932 33.837 22.023 63.683 55.739 66.661 33.715 2.979 63.424-22.038 66.355-55.876 2.932-33.837-22.023-63.683-55.739-66.661"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#002842",
    strokeWidth: 1.2,
    d: "M84.624 157.646v-23.97c-9.778-7.765-16.041-19.74-16.041-33.176 0-23.42 19.038-42.404 42.52-42.404 22.791 0 41.392 17.881 42.468 40.346l7.304 18.88c1.053 2.722-.318 5.809-3.05 6.859l-6.445 2.486v14.082c0 4.866-3.988 8.845-8.867 8.845h-13.61v19.903"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M138.571 43.438c1.228-.794 1.869-1.39 1.924-1.787.05-.363 0-8.714 0-10.257 0-.408-.641-1.047-1.924-1.916H76.126v13.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#032D47",
    d: "M78.205 43.058h60.076c.816 0 1.479-.688 1.479-1.533V31.392c0-.845-.663-1.533-1.479-1.533H78.205v13.199zm60.076.761H77.838a.374.374 0 0 1-.368-.38v-13.96c0-.211.165-.382.368-.382h60.443c1.22 0 2.214 1.03 2.214 2.295v10.133c0 1.265-.993 2.294-2.214 2.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M85.052 38.797a.374.374 0 0 1-.367-.38v-4.014c0-.21.164-.381.367-.381.203 0 .367.17.367.38v4.014c0 .21-.164.381-.367.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M83.683 38.21a.36.36 0 0 1-.26-.112.39.39 0 0 1 0-.539l2.738-2.838a.358.358 0 0 1 .519 0 .39.39 0 0 1 0 .539l-2.737 2.838a.36.36 0 0 1-.26.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M86.988 36.79h-3.872a.374.374 0 0 1-.367-.38c0-.21.164-.381.367-.381h3.872c.203 0 .367.17.367.38s-.164.381-.367.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M86.42 38.21a.36.36 0 0 1-.26-.112l-2.737-2.838a.39.39 0 0 1 0-.539.358.358 0 0 1 .52 0l2.737 2.838a.39.39 0 0 1 0 .539.36.36 0 0 1-.26.112M94.478 38.797a.374.374 0 0 1-.367-.38v-4.014c0-.21.164-.381.367-.381.203 0 .368.17.368.38v4.014c0 .21-.165.381-.368.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M93.11 38.21a.36.36 0 0 1-.26-.112.39.39 0 0 1 0-.539l2.737-2.838a.358.358 0 0 1 .52 0 .39.39 0 0 1 0 .539l-2.738 2.838a.36.36 0 0 1-.26.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M96.414 36.79h-3.872a.374.374 0 0 1-.367-.38c0-.21.164-.381.367-.381h3.872c.203 0 .367.17.367.38s-.164.381-.367.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M95.847 38.21a.36.36 0 0 1-.26-.112L92.85 35.26a.39.39 0 0 1 0-.539.358.358 0 0 1 .52 0l2.736 2.838a.39.39 0 0 1 0 .539.36.36 0 0 1-.26.112M103.905 38.797a.374.374 0 0 1-.368-.38v-4.014c0-.21.164-.381.368-.381.203 0 .367.17.367.38v4.014c0 .21-.164.381-.367.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M102.536 38.21a.36.36 0 0 1-.26-.112.39.39 0 0 1 0-.539l2.738-2.838a.358.358 0 0 1 .52 0 .39.39 0 0 1 0 .539l-2.739 2.838a.36.36 0 0 1-.26.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M105.84 36.79h-3.871a.374.374 0 0 1-.368-.38c0-.21.164-.381.368-.381h3.871c.203 0 .368.17.368.38s-.165.381-.368.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M105.273 38.21a.36.36 0 0 1-.26-.112l-2.737-2.838a.39.39 0 0 1 0-.539.358.358 0 0 1 .52 0l2.737 2.838a.39.39 0 0 1 0 .539.36.36 0 0 1-.26.112M113.331 38.797a.374.374 0 0 1-.367-.38v-4.014c0-.21.164-.381.367-.381.203 0 .367.17.367.38v4.014c0 .21-.164.381-.367.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M111.962 38.21a.36.36 0 0 1-.26-.112.39.39 0 0 1 0-.539l2.738-2.838a.358.358 0 0 1 .52 0 .39.39 0 0 1 0 .539l-2.738 2.838a.36.36 0 0 1-.26.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M115.267 36.79h-3.872a.374.374 0 0 1-.367-.38c0-.21.164-.381.367-.381h3.872c.203 0 .367.17.367.38s-.164.381-.367.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M114.7 38.21a.36.36 0 0 1-.26-.112l-2.738-2.838a.39.39 0 0 1 0-.539.358.358 0 0 1 .52 0l2.737 2.838a.39.39 0 0 1 0 .539.36.36 0 0 1-.26.112M122.757 38.797a.374.374 0 0 1-.367-.38v-4.014c0-.21.164-.381.367-.381.203 0 .368.17.368.38v4.014c0 .21-.165.381-.368.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M121.388 38.21a.36.36 0 0 1-.26-.112.39.39 0 0 1 0-.539l2.738-2.838a.358.358 0 0 1 .52 0 .39.39 0 0 1 0 .539l-2.738 2.838a.36.36 0 0 1-.26.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M124.693 36.79h-3.871a.374.374 0 0 1-.368-.38c0-.21.165-.381.368-.381h3.87c.204 0 .368.17.368.38s-.164.381-.367.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M124.126 38.21a.36.36 0 0 1-.26-.112l-2.737-2.838a.39.39 0 0 1 0-.539.358.358 0 0 1 .52 0l2.737 2.838a.39.39 0 0 1 0 .539.36.36 0 0 1-.26.112M132.184 38.797a.374.374 0 0 1-.368-.38v-4.014c0-.21.165-.381.368-.381.203 0 .367.17.367.38v4.014c0 .21-.164.381-.367.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M130.815 38.21a.36.36 0 0 1-.26-.112.39.39 0 0 1 0-.539l2.738-2.838a.358.358 0 0 1 .52 0 .39.39 0 0 1 0 .539l-2.739 2.838a.36.36 0 0 1-.26.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M134.12 36.79h-3.872a.374.374 0 0 1-.367-.38c0-.21.164-.381.367-.381h3.871c.203 0 .368.17.368.38s-.165.381-.368.381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M133.552 38.21a.36.36 0 0 1-.26-.112l-2.737-2.838a.39.39 0 0 1 0-.539.358.358 0 0 1 .52 0l2.737 2.838a.39.39 0 0 1 0 .539.36.36 0 0 1-.26.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFBDC4",
    stroke: "#032D47",
    strokeWidth: 1.2,
    d: "M65.84 43.438h11.998v-13.96H65.84c-.812 0-1.47.682-1.47 1.523v10.914c0 .841.658 1.523 1.47 1.523"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#032D47",
    d: "M78.205 43.058h60.076c.816 0 1.479-.688 1.479-1.533V31.392c0-.845-.663-1.533-1.479-1.533H78.205v13.199zm60.076.761H77.838a.374.374 0 0 1-.368-.38v-13.96c0-.211.165-.382.368-.382h60.443c1.22 0 2.214 1.03 2.214 2.295v10.133c0 1.265-.993 2.294-2.214 2.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFBDC4",
    stroke: "#032D47",
    strokeWidth: 1.2,
    d: "M65.84 43.438h11.998v-13.96H65.84c-.812 0-1.47.682-1.47 1.523v10.914c0 .841.658 1.523 1.47 1.523"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.885 36.458c0-1.27.994-2.301 2.22-2.301 1.226 0 2.22 1.03 2.22 2.301 0 1.271-.994 2.302-2.22 2.302-1.226 0-2.22-1.03-2.22-2.302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B7687",
    d: "M102.493 90.294a.374.374 0 0 1-.367-.38V80.55c0-.21.164-.381.367-.381.204 0 .368.17.368.38v9.363c0 .21-.164.381-.368.381M102.493 77.124a.374.374 0 0 1-.367-.381v-6.834c0-.21.164-.381.367-.381.204 0 .368.17.368.38v6.835c0 .21-.164.38-.368.38M102.493 66.481a.374.374 0 0 1-.367-.38V43.826c0-.21.164-.381.367-.381.204 0 .368.17.368.38v22.276c0 .21-.164.38-.368.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#5B7687"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.974 102.988c-.2-.167-.25-.433-.115-.595l6.04-7.198c.136-.162.407-.158.606.01.2.166.25.433.115.594l-6.04 7.199c-.136.161-.407.157-.606-.01M140.682 92.61c-.199-.168-.254-.429-.123-.585l4.244-5.058c.13-.155.397-.146.597.02.199.168.254.43.123.585l-4.244 5.058c-.13.156-.397.147-.597-.02M147.214 84.826c-.2-.167-.25-.434-.115-.596l14.386-17.144c.136-.161.407-.157.606.01.2.167.25.433.115.595L147.82 84.835c-.136.162-.407.158-.606-.01"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M183.794 69.155c1.017-.793 1.548-1.387 1.593-1.783.042-.362 0-8.691 0-10.231 0-.407-.53-1.044-1.593-1.91h-51.719v13.924"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#032D47",
    d: "M134.041 68.775h50.836c.69 0 1.251-.686 1.251-1.53V57.14c0-.843-.561-1.529-1.251-1.529h-50.836v13.165zm50.836.76H133.73c-.171 0-.31-.17-.31-.38V55.23c0-.21.139-.38.31-.38h51.147c1.033 0 1.873 1.027 1.873 2.29v10.106c0 1.262-.84 2.289-1.873 2.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M141.001 64.526a.374.374 0 0 1-.367-.38v-4.004c0-.21.164-.38.367-.38.203 0 .367.17.367.38v4.004c0 .21-.164.38-.367.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M139.632 63.94a.36.36 0 0 1-.26-.112.389.389 0 0 1 0-.537l2.738-2.83a.36.36 0 0 1 .52 0 .389.389 0 0 1 0 .536l-2.738 2.831a.36.36 0 0 1-.26.111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M142.937 62.524h-3.872a.374.374 0 0 1-.367-.38c0-.21.164-.38.367-.38h3.872c.203 0 .367.17.367.38s-.164.38-.367.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M142.37 63.94a.36.36 0 0 1-.26-.112l-2.737-2.83a.389.389 0 0 1 0-.538.36.36 0 0 1 .519 0l2.737 2.83a.389.389 0 0 1 0 .538.36.36 0 0 1-.26.111M150.427 64.526a.374.374 0 0 1-.367-.38v-4.004c0-.21.164-.38.367-.38.204 0 .368.17.368.38v4.004c0 .21-.164.38-.368.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M149.059 63.94a.36.36 0 0 1-.26-.112.389.389 0 0 1 0-.537l2.737-2.83a.36.36 0 0 1 .52 0 .389.389 0 0 1 0 .536l-2.738 2.831a.36.36 0 0 1-.26.111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M152.363 62.524h-3.872a.374.374 0 0 1-.367-.38c0-.21.164-.38.367-.38h3.872c.203 0 .367.17.367.38s-.164.38-.367.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M151.796 63.94a.36.36 0 0 1-.26-.112l-2.737-2.83a.389.389 0 0 1 0-.538.36.36 0 0 1 .52 0l2.737 2.83a.389.389 0 0 1 0 .538.36.36 0 0 1-.26.111M159.854 64.526a.374.374 0 0 1-.368-.38v-4.004c0-.21.165-.38.368-.38.203 0 .367.17.367.38v4.004c0 .21-.164.38-.367.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M158.485 63.94a.36.36 0 0 1-.26-.112.389.389 0 0 1 0-.537l2.738-2.83a.36.36 0 0 1 .52 0 .389.389 0 0 1 0 .536l-2.738 2.831a.36.36 0 0 1-.26.111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M161.79 62.524h-3.872a.374.374 0 0 1-.368-.38c0-.21.165-.38.368-.38h3.871c.204 0 .368.17.368.38s-.164.38-.368.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M161.223 63.94a.36.36 0 0 1-.26-.112l-2.738-2.83a.389.389 0 0 1 0-.538.36.36 0 0 1 .52 0l2.737 2.83a.389.389 0 0 1 0 .538.36.36 0 0 1-.26.111M169.28 64.526a.374.374 0 0 1-.367-.38v-4.004c0-.21.164-.38.367-.38.203 0 .367.17.367.38v4.004c0 .21-.164.38-.367.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M167.911 63.94a.36.36 0 0 1-.26-.112.389.389 0 0 1 0-.537l2.738-2.83a.36.36 0 0 1 .52 0 .389.389 0 0 1 0 .536l-2.738 2.831a.36.36 0 0 1-.26.111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M171.216 62.524h-3.872a.374.374 0 0 1-.367-.38c0-.21.164-.38.367-.38h3.872c.203 0 .367.17.367.38s-.164.38-.367.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M170.649 63.94a.36.36 0 0 1-.26-.112l-2.737-2.83a.389.389 0 0 1 0-.538.36.36 0 0 1 .519 0l2.738 2.83a.389.389 0 0 1 0 .538.36.36 0 0 1-.26.111M178.707 64.526a.374.374 0 0 1-.368-.38v-4.004c0-.21.164-.38.368-.38.203 0 .367.17.367.38v4.004c0 .21-.164.38-.367.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M177.338 63.94a.36.36 0 0 1-.26-.112.389.389 0 0 1 0-.537l2.738-2.83a.36.36 0 0 1 .519 0 .389.389 0 0 1 0 .536l-2.738 2.831a.36.36 0 0 1-.26.111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M180.642 62.524h-3.871a.374.374 0 0 1-.367-.38c0-.21.164-.38.367-.38h3.871c.203 0 .367.17.367.38s-.164.38-.367.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M180.075 63.94a.36.36 0 0 1-.26-.112l-2.737-2.83a.389.389 0 0 1 0-.538.36.36 0 0 1 .52 0l2.737 2.83a.389.389 0 0 1 0 .538.36.36 0 0 1-.26.111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFBDC4",
    stroke: "#032D47",
    strokeWidth: 1.2,
    d: "M121.79 69.155h11.997V55.23H121.79c-.811 0-1.47.68-1.47 1.52v10.885c0 .84.659 1.52 1.47 1.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#032D47",
    d: "M134.041 68.775h50.836c.69 0 1.251-.686 1.251-1.53V57.14c0-.843-.561-1.529-1.251-1.529h-50.836v13.165zm50.836.76H133.73c-.171 0-.31-.17-.31-.38V55.23c0-.21.139-.38.31-.38h51.147c1.033 0 1.873 1.027 1.873 2.29v10.106c0 1.262-.84 2.289-1.873 2.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFBDC4",
    stroke: "#032D47",
    strokeWidth: 1.2,
    d: "M121.79 69.155h11.997V55.23H121.79c-.811 0-1.47.68-1.47 1.52v10.885c0 .84.659 1.52 1.47 1.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M124.834 62.192c0-1.267.994-2.295 2.22-2.295 1.226 0 2.22 1.028 2.22 2.295 0 1.268-.994 2.296-2.22 2.296-1.226 0-2.22-1.028-2.22-2.296"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#5B7687"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.856 102.265a.375.375 0 0 1 .125.514l-4.706 8.152a.375.375 0 0 1-.508.148.375.375 0 0 1-.126-.514l4.706-8.152a.375.375 0 0 1 .509-.148M92.235 113.732a.375.375 0 0 1 .126.514l-3.436 5.95a.375.375 0 0 1-.508.15.375.375 0 0 1-.126-.516l3.436-5.95a.375.375 0 0 1 .508-.148M86.886 122.997a.375.375 0 0 1 .125.515l-11.197 19.394a.375.375 0 0 1-.508.148.375.375 0 0 1-.126-.514l11.197-19.394a.375.375 0 0 1 .509-.149"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M115.455 146.742c1.223-.798 1.862-1.397 1.916-1.797.05-.365 0-8.76 0-10.312 0-.41-.638-1.051-1.916-1.925h-62.23v14.034"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#032D47",
    d: "M55.296 146.36h59.87c.812 0 1.473-.692 1.473-1.542v-10.186c0-.85-.66-1.541-1.473-1.541h-59.87v13.269zm59.87.765H54.93a.375.375 0 0 1-.366-.382v-14.035c0-.212.164-.383.366-.383h60.236c1.216 0 2.205 1.035 2.205 2.307v10.186c0 1.272-.989 2.307-2.205 2.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M62.12 142.077a.375.375 0 0 1-.366-.383v-4.035c0-.212.163-.383.366-.383.202 0 .366.171.366.383v4.035a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M60.756 141.486a.357.357 0 0 1-.26-.112.395.395 0 0 1 0-.542l2.729-2.853a.355.355 0 0 1 .517 0 .395.395 0 0 1 0 .541l-2.728 2.854a.357.357 0 0 1-.258.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M64.049 140.059H60.19a.375.375 0 0 1-.366-.383c0-.211.164-.383.366-.383h3.859c.202 0 .366.172.366.383a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M63.483 141.486a.357.357 0 0 1-.258-.112l-2.728-2.854a.395.395 0 0 1 0-.541.355.355 0 0 1 .517 0l2.728 2.853a.395.395 0 0 1 0 .542.357.357 0 0 1-.259.112M71.514 142.077a.375.375 0 0 1-.367-.383v-4.035c0-.212.164-.383.367-.383.202 0 .366.171.366.383v4.035a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M70.15 141.486a.357.357 0 0 1-.26-.112.395.395 0 0 1 0-.542l2.728-2.853a.355.355 0 0 1 .518 0 .395.395 0 0 1 0 .541l-2.728 2.854a.357.357 0 0 1-.259.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M73.443 140.059h-3.859a.375.375 0 0 1-.366-.383c0-.211.164-.383.366-.383h3.859c.202 0 .366.172.366.383a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M72.877 141.486a.357.357 0 0 1-.258-.112l-2.728-2.854a.395.395 0 0 1 0-.541.355.355 0 0 1 .517 0l2.728 2.853a.395.395 0 0 1 0 .542.357.357 0 0 1-.259.112M80.907 142.077a.375.375 0 0 1-.366-.383v-4.035c0-.212.164-.383.366-.383.203 0 .367.171.367.383v4.035a.375.375 0 0 1-.367.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M79.543 141.486a.357.357 0 0 1-.259-.112.395.395 0 0 1 0-.542l2.729-2.853a.355.355 0 0 1 .517 0 .395.395 0 0 1 0 .541l-2.728 2.854a.357.357 0 0 1-.259.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M82.836 140.059h-3.858a.375.375 0 0 1-.366-.383c0-.211.164-.383.366-.383h3.858c.203 0 .366.172.366.383a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M82.272 141.486a.357.357 0 0 1-.26-.112l-2.727-2.854a.395.395 0 0 1 0-.541.355.355 0 0 1 .517 0l2.728 2.853a.395.395 0 0 1 0 .542.357.357 0 0 1-.258.112M90.301 142.077a.375.375 0 0 1-.366-.383v-4.035c0-.212.164-.383.366-.383.203 0 .366.171.366.383v4.035a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M88.937 141.486a.357.357 0 0 1-.259-.112.395.395 0 0 1 0-.542l2.729-2.853a.355.355 0 0 1 .517 0 .395.395 0 0 1 0 .541l-2.728 2.854a.357.357 0 0 1-.259.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M92.23 140.059h-3.858a.375.375 0 0 1-.366-.383c0-.211.164-.383.366-.383h3.858c.203 0 .366.172.366.383a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M91.665 141.486a.357.357 0 0 1-.258-.112l-2.729-2.854a.395.395 0 0 1 0-.541.355.355 0 0 1 .518 0l2.728 2.853a.395.395 0 0 1 0 .542.357.357 0 0 1-.259.112M99.695 142.077a.375.375 0 0 1-.366-.383v-4.035c0-.212.164-.383.366-.383.203 0 .366.171.366.383v4.035a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M98.331 141.486a.357.357 0 0 1-.259-.112.395.395 0 0 1 0-.542l2.728-2.853a.355.355 0 0 1 .518 0 .395.395 0 0 1 0 .541l-2.728 2.854a.357.357 0 0 1-.259.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M101.624 140.059h-3.858a.375.375 0 0 1-.366-.383c0-.211.164-.383.366-.383h3.858c.203 0 .366.172.366.383a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M101.06 141.486a.357.357 0 0 1-.26-.112l-2.728-2.854a.395.395 0 0 1 0-.541.355.355 0 0 1 .518 0l2.728 2.853a.395.395 0 0 1 0 .542.357.357 0 0 1-.259.112M109.09 142.077a.375.375 0 0 1-.367-.383v-4.035c0-.212.164-.383.366-.383.203 0 .366.171.366.383v4.035a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M107.725 141.486a.357.357 0 0 1-.259-.112.395.395 0 0 1 0-.542l2.728-2.853a.355.355 0 0 1 .518 0 .395.395 0 0 1 0 .541l-2.728 2.854a.357.357 0 0 1-.26.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M111.018 140.059h-3.858a.375.375 0 0 1-.366-.383c0-.211.164-.383.366-.383h3.858c.202 0 .366.172.366.383a.375.375 0 0 1-.366.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0049",
    d: "M110.453 141.486a.357.357 0 0 1-.259-.112l-2.728-2.854a.395.395 0 0 1 0-.541.355.355 0 0 1 .518 0l2.728 2.853a.395.395 0 0 1 0 .542.357.357 0 0 1-.259.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFBDC4",
    stroke: "#032D47",
    strokeWidth: 1.2,
    d: "M42.975 146.742H54.93v-14.034H42.975c-.809 0-1.464.685-1.464 1.531v10.972c0 .846.655 1.531 1.464 1.531"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#032D47",
    d: "M55.296 146.36h59.87c.812 0 1.473-.692 1.473-1.542v-10.186c0-.85-.66-1.541-1.473-1.541h-59.87v13.269zm59.87.765H54.93a.375.375 0 0 1-.366-.382v-14.035c0-.212.164-.383.366-.383h60.236c1.216 0 2.205 1.035 2.205 2.307v10.186c0 1.272-.989 2.307-2.205 2.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFBDC4",
    stroke: "#032D47",
    strokeWidth: 1.2,
    d: "M42.975 146.742H54.93v-14.034H42.975c-.809 0-1.464.685-1.464 1.531v10.972c0 .846.655 1.531 1.464 1.531"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46.008 139.725c0-1.278.99-2.314 2.213-2.314 1.222 0 2.212 1.036 2.212 2.314s-.99 2.314-2.212 2.314c-1.222 0-2.213-1.036-2.213-2.314"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD5DA",
    fillOpacity: 0.558,
    stroke: "#002B45",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M122.83 116.788c-3.15-.11-5.623-2.752-5.514-5.884.11-3.138 2.762-5.599 5.912-5.489 3.15.11 5.622 2.75 5.512 5.887-.11 3.133-2.76 5.596-5.91 5.486z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#002B45",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CDD5DA",
    fillOpacity: 0.558,
    d: "M105.175 96.385c-3.38 1.365-7.225-.24-8.572-3.572-1.348-3.338.305-7.162 3.684-8.527 3.378-1.365 7.222.238 8.57 3.576 1.347 3.332-.304 7.158-3.682 8.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 87.396l-2.31-5.717-3.555 1.436a11.688 11.688 0 0 0-2.197-2.205l1.51-3.535-5.694-2.402-1.526 3.572a12.013 12.013 0 0 0-3.08-.01l-1.457-3.606-5.743 2.32 1.453 3.597a12.014 12.014 0 0 0-2.225 2.148l-3.559-1.502-2.427 5.684 3.507 1.48a11.712 11.712 0 0 0-.054 3.143l-3.515 1.42 2.31 5.718 3.516-1.42c.644.845 1.392 1.59 2.222 2.222l-1.495 3.501 5.694 2.403 1.518-3.555c1.014.133 2.051.132 3.09 0l1.454 3.598 5.743-2.32-1.458-3.608a12.024 12.024 0 0 0 2.208-2.146l3.581 1.511 2.428-5.684-3.543-1.494c.154-1.021.172-2.066.049-3.112l3.556-1.437z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#002B45",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M135.864 114.14l.181-5.175-3.218-.113a9.813 9.813 0 0 0-.932-2.441l2.366-2.197-3.548-3.787-2.39 2.219a10.086 10.086 0 0 0-2.36-1.06l.114-3.263-5.198-.181-.114 3.255a10.09 10.09 0 0 0-2.44.888l-2.217-2.367-3.804 3.53 2.185 2.333a9.836 9.836 0 0 0-1.115 2.393l-3.182-.11-.181 5.175 3.182.11c.206.87.525 1.696.946 2.464l-2.344 2.176 3.548 3.788 2.38-2.209a10.09 10.09 0 0 0 2.37 1.055l-.114 3.257 5.198.181.114-3.265a10.098 10.098 0 0 0 2.426-.892l2.231 2.382 3.804-3.531-2.207-2.357a9.805 9.805 0 0 0 1.1-2.37l3.22.112z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.570be398dfba051d941f0e3aa210eeb7.svg";
export { ForwardRef as ReactComponent };